import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { type Block, type Inline, INLINES } from '@contentful/rich-text-types';
import { Hyperlink } from '@snapchat/snap-design-system-marketing';
import type { ReactNode } from 'react';

import type { RichText } from '../../../types/RichText';

const linkOptions = {
  renderNode: {
    [INLINES.HYPERLINK]: (node: Block | Inline, children: ReactNode) => {
      const uri = node.data.uri;
      return (
        <Hyperlink link={uri} target="_blank">
          {children}
        </Hyperlink>
      );
    },
  },
};

export const customRenderParagraph = (data?: RichText | string): ReactNode => {
  if (!data) {
    return undefined;
  }

  if (typeof data === 'string') {
    return data;
  }

  return documentToReactComponents(data.json, linkOptions);
};
